import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { Trans, useTranslation } from "react-i18next";
import ExportExcel from "./Export";
import { useMsal } from "@azure/msal-react";
import { findCountriesWithRoles } from "../../utils/utils";

interface Props {
  setDate: React.Dispatch<React.SetStateAction<string[]>>;
  // setStartDate: React.Dispatch<React.SetStateAction<Date>>;
  // setEndDate: React.Dispatch<React.SetStateAction<Date>>;
  setCountry: React.Dispatch<React.SetStateAction<string>>;
  setInstitutionId: React.Dispatch<React.SetStateAction<string>>;
  setEvent: React.Dispatch<React.SetStateAction<string>>;
  setStatus: React.Dispatch<React.SetStateAction<string>>;
  event: string;
  perimeter: string;
  status: string;
  institutionId: string;
  period: string[];
}

const TopOfDashboard: React.FC<Props> = ({
  setDate,
  // setStartDate,
  // setEndDate,
  setCountry,
  setInstitutionId,
  setEvent,
  setStatus,
  event,
  perimeter,
  status,
  institutionId,
  period,
}) => {
  const [dateRange, setDateRange] = useState<[null | Date, null | Date]>([
    null,
    null,
  ]);

  const { accounts } = useMsal();
  const roles = accounts[0]?.idTokenClaims?.roles;
  const countries = findCountriesWithRoles(roles);

  const [startDate, endDate] = dateRange;

  const { t } = useTranslation();
  const selectClass =
    "border-[#F1F1F1] min-w-[12rem] p-2 invalid:text-gray-500 h-10 border-gray-500 invalid:font-ABeeZee invalid:italic [box-shadow:0px_0px_3px_rgba(0,0,0,0.25)]";

  return (
    <>
      <div>
        <h1 className="text-4xl font-Poppins font-bold mb-14">
          <Trans i18nKey="Events Dashboard">Events Dashboard</Trans>
        </h1>
        <div className="w-fit flex items-center gap-2">
          <DatePicker
            filterDate={(d) => {
              return new Date() > d;
            }}
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            onChange={(update) => {
              setDateRange(update);
              setDate([update[0]?.toString()!, update[1]?.toString()!]);
              // setStartDate(update[0])
            }}
            isClearable={true}
            dateFormat={"d MMM yyyy"}
            placeholderText={t("Period")}
            className="w-fit h-full m-0 border border-[#F1F1F1] [box-shadow:0px_0px_3px_rgba(0,0,0,0.25)]"
          />
        </div>
        <div className="flex flex-wrap items-center gap-5 my-5">
          <div className="flex flex-wrap flex-grow items-center gap-5">
            <select
              name="country"
              id="country"
              required
              className={selectClass}
              defaultValue=""
              onChange={(e) => setCountry(e.target.value)}
            >
              <option value="">{t("All")}</option>
              {countries.includes("all") ? (
                <>
                  <option value="Argentina">Argentina</option>
                  <option value="Belgium">Belgium</option>
                  <option value="Colombia">Colombia</option>
                  <option value="France">France</option>
                  <option value="Germany">Germany</option>
                  <option value="India">India</option>
                  <option value="Luxembourg">Luxembourg</option>
                  <option value="Netherlands">Netherlands</option>
                  <option value="Reunion">Reunion</option>
                  <option value="Singapore">Singapore</option>
                  <option value="Switzerland">Switzerland</option>
                  <option value="UAE">UAE</option>
                  <option value="USA">USA</option>
                </>
              ) : (
                countries?.map((country) => (
                  <option key={country} value={country}>
                    {country}
                  </option>
                ))
              )}
            </select>
            <select
              name="eventType"
              id="eventType"
              required
              className={selectClass}
              defaultValue=""
              onChange={(e) => setEvent(e.target.value)}
            >
              <option value="">{t("All")}</option>
              <option value="Incidents">Incidents</option>
              <option value="Health event">Health event</option>
              <option value="Other safety events">Other safety events</option>
              <option value="Epidemic">Epidemic</option>
              <option value="Food Safety Issue">Food Safety Issue</option>
              <option value="Nothing to declare">Nothing to declare</option>
            </select>
            <input
              type="text"
              name="estName"
              className={
                selectClass + " placeholder:italic placeholder:font-ABeeZee"
              }
              placeholder={t(`Institution Id`)}
              onChange={(e) => setInstitutionId(e.target.value)}
            />
            <select
              name="status"
              id="status"
              required
              className={selectClass}
              defaultValue=""
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">{t("All")}</option>
              <option value="Need Validation">Need Validation</option>
              <option value="Closed">Closed</option>
              <option value="Deleted">Deleted</option>
            </select>
          </div>
          <div className="flex justify-end">
            <ExportExcel
              status={status}
              perimeter={perimeter}
              institutionId={institutionId}
              event={event}
              period={period}
              fileName="filtered-data"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TopOfDashboard;
